import React from 'react'
import '../AssessmentCompleted/assessment.css'

export default function AssessmentCompleted() {
  return (
<div className='expired-page'>
  <div style={{ background:'rgba(0,0,0,.7)',margin:'50px',padding:'50px',color:'white',width:'fit-content'}}> 
    <h3 className="expiry-link-heading" style={{textAlign:'center'}}>This assessment is completed!</h3>
    <div className="invalid-link-reasons">
      <h5 className="expiry-link-heading" style={{textAlign:'center'}}>Thank you for your response</h5>
    </div>
  </div>
</div>

  )
}

//test



// WEBPACK FOOTER //
// ./src/_pages/AssessmentCompleted/index.jsx